import React, { memo } from "react";
import cls from "classnames";
import { useCtx } from "@al/next/al-ex";
import { PriceTools, CountryCode } from "@al/base-lib";

import styles from "./styles.scss";

type Props = Omit<React.HtmlHTMLAttributes<HTMLSpanElement>, "children"> & {
  value: number | string;
};

const LineThroughPrice: React.FC<Props> = (props) => {
  const { className, value, ...others } = props;
  const ctx = useCtx();

  return (
    <span className={cls(styles.line_through, className)} {...others}>
      {PriceTools.formatPrice(ctx.locale.countryCode as CountryCode, value || 0, "price")}
    </span>
  );
};

export default memo<Props>(LineThroughPrice);
